<template>
  <div>
    <div class="inco-assessment-subtitle mb-10">{{ $t('text.summary') }}</div>
    <el-row
      class="inco-assessment-summary-module"
      v-loading="loading"
      :gutter="20"
    >
      <el-col :xs="24" :lg="12" class="summary-module-block">
        <el-row>
          <el-col :xs="24" :lg="3">
            <div class="pad-circle v-h-center">
              <img src="@/assets/image/inco-assessment/pad.png" />
            </div>
          </el-col>
          <el-col :xs="24" :lg="21">
            <!-- incontinent event frquency -->
            <div class="title mb-5">
              {{ $t('text.incontinent_event_frquency') }}
            </div>
            <el-row :gutter="10">
              <el-col :xs="24" :lg="8"
                >{{ $t('text.bladder_daily') }}:
                {{
                  summaryData && summaryData.EventFrequency
                    ? _.round(summaryData.EventFrequency.BladderPerDay, 2)
                    : '--'
                }}
                {{ $t('text.times') }} /
                {{ $t('text.day').toLowerCase() }}</el-col
              >
              <el-col :xs="24" :lg="8"
                >{{ $t('text.weekly') }}:
                {{
                  summaryData && summaryData.EventFrequency
                    ? _.round(summaryData.EventFrequency.BladderPerDay * 7, 2)
                    : '--'
                }}
                {{ $t('text.times') }} / {{ $t('text.week') }}</el-col
              >
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :lg="8"
                >{{ $t('text.bowel_daily') }}:
                {{
                  summaryData && summaryData.EventFrequency
                    ? _.round(summaryData.EventFrequency.BowelPerDay, 2)
                    : '--'
                }}
                {{ $t('text.times') }} /
                {{ $t('text.day').toLowerCase() }}</el-col
              >
              <el-col :xs="24" :lg="8"
                >{{ $t('text.weekly') }}:
                {{
                  summaryData && summaryData.EventFrequency
                    ? _.round(summaryData.EventFrequency.BowelPerDay * 7, 2)
                    : '--'
                }}
                {{ $t('text.times') }} / {{ $t('text.week') }}</el-col
              >
            </el-row>
            <!-- diaper utilisation -->
            <div class="title mt-10">
              {{
                $t('text.diaper_utilisation', {
                  pad: $firstLetterCapitalize($store.state.locale.pad)
                })
              }}
            </div>
            <el-row :gutter="10">
              <el-col :xs="24" :lg="8"
                >{{
                  $t('text.day_pad', {
                    pad: $firstLetterCapitalize($store.state.locale.pad)
                  })
                }}:
                {{
                  summaryData && summaryData.DiaperUtilisation
                    ? summaryData.DiaperUtilisation.DayPad
                    : '--'
                }}</el-col
              >
              <el-col :xs="24" :lg="8"
                >{{ $t('text.usage') }}:
                {{
                  summaryData && summaryData.DiaperUtilisation
                    ? summaryData.DiaperUtilisation.DayPadUsage
                    : '--'
                }}
                {{ $t('text.units_during_day') }}</el-col
              >
              <el-col :xs="24" :lg="8"
                >{{ $t('text.average_fill') }}:
                {{
                  summaryData && summaryData.DiaperUtilisation
                    ? summaryData.DiaperUtilisation.DayPadAverageFill
                    : '--'
                }}</el-col
              >
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :lg="8"
                >{{
                  $t('text.night_pad', {
                    pad: $firstLetterCapitalize($store.state.locale.pad)
                  })
                }}:
                {{
                  summaryData && summaryData.DiaperUtilisation
                    ? summaryData.DiaperUtilisation.NightPad
                    : '--'
                }}</el-col
              >
              <el-col :xs="24" :lg="8"
                >{{ $t('text.usage') }}:
                {{
                  summaryData && summaryData.DiaperUtilisation
                    ? summaryData.DiaperUtilisation.NightPadUsage
                    : '--'
                }}
                {{ $t('text.unit_at_night') }}</el-col
              >
              <el-col :xs="24" :lg="8"
                >{{ $t('text.average_fill') }}:
                {{
                  summaryData && summaryData.DiaperUtilisation
                    ? summaryData.DiaperUtilisation.NightPadAverageFill
                    : '--'
                }}</el-col
              >
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <el-col :xs="24" :lg="12" class="summary-module-block">
        <div class="mb-5">
          <span class="title mr-10">{{ $t('text.Period') }}</span>
          <span
            >{{ datePeriodStr }} ({{ datePeriodDuration }}
            {{ $t('text.hours') }})</span
          >
        </div>
        <el-row :gutter="20">
          <!-- observations -->
          <el-col :xs="24" :lg="12">
            <div>
              <span class="title mr-10">{{ $t('text.Observations') }}</span>
              <span class="text-a pointer" @click="openShowObservationsModal()"
                >({{ $t('text.view') }})</span
              >
            </div>
            <div v-if="observations.length">
              <div v-for="(item, key) in observations" :key="key">
                <div v-if="key <= 2">
                  <span>{{ item.ObservationName }}</span
                  >:
                  <span>{{ item.ObservationCount }}</span>
                </div>
              </div>
            </div>
            <div v-else class="secondary-font mt-3">
              {{ $t('text.No_Observations') }}
            </div>
          </el-col>
          <!-- daily quality -->
          <el-col :xs="24" :lg="12">
            <div>
              <span class="title mr-10">{{ $t('text.data_quality') }}</span>
              <el-rate
                v-model="dataQuality"
                class="inline-block"
                disabled
              ></el-rate>
            </div>
            <div>
              {{ $t('text.pod_out_of_range') }}:
              {{
                summaryData ? secondsToHours(summaryData.PodOutOfRange) : '--'
              }}
              ({{
                summaryData ? summaryData.PodOutOfRangePercentage + '%' : ''
              }})
            </div>
            <div>
              {{ $t('text.external_humidity') }}:
              {{
                summaryData
                  ? secondsToHours(summaryData.ExternalHumidity)
                  : '--'
              }}
              ({{
                summaryData ? summaryData.ExternalHumidityPercentage + '%' : ''
              }})
            </div>
            <div>
              {{ $t('text.Observations') }}:&lt;
              {{ `${summaryData ? summaryData.ObservationsPerDay : '--'}` }}
              {{ $t('text.per_day') }}
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <ShowObservations ref="showObservations" :observations="observations" />
  </div>
</template>

<script>
import moment from 'moment'
import ShowObservations from '@/components/patients/incoAssessment/ShowObservations'
export default {
  data() {
    return {
      dataQuality: 0,
      datePeriodStr: '',
      datePeriodDuration: 0
    }
  },
  components: {
    ShowObservations
  },
  props: {
    summaryData: {
      type: [Object, null],
      require: true
    },
    loading: {
      type: Boolean,
      require: true
    }
  },
  watch: {
    '$store.state.patient.selectedDateRange': {
      immediate: true,
      handler() {
        this.getPeriodInfo()
      }
    },
    summaryData() {
      this.dataQuality = this.summaryData ? this.summaryData.DataQuality : 0
    }
  },
  computed: {
    observations() {
      if (!this.summaryData || !this.summaryData.Observations) return []
      return this.summaryData.Observations.slice().sort(
        (a, b) => b.ObservationCount - a.ObservationCount
      )
    }
  },
  methods: {
    getPeriodInfo() {
      this.datePeriodStr =
        moment(this.$store.state.patient.selectedDateRange[0]).format(
          'DD/MM/YY'
        ) +
        ' to ' +
        moment(this.$store.state.patient.selectedDateRange[1]).format(
          'DD/MM/YY'
        )
      this.datePeriodDuration = moment(
        this.$store.state.patient.selectedDateRange[1]
      ).diff(moment(this.$store.state.patient.selectedDateRange[0]), 'hours')
    },
    secondsToHours(seconds) {
      const hours = Math.floor(seconds / 3600)
      const remainingSeconds = seconds % 3600
      const minutes = Math.floor(remainingSeconds / 60)
      const remainingSecondsInSeconds = remainingSeconds % 60

      let str = `${hours}h`
      if (minutes) {
        str += `${minutes}m`
        if (remainingSecondsInSeconds) {
          str += `${remainingSecondsInSeconds}s`
        }
      }
      return str
    },
    openShowObservationsModal() {
      this.$refs.showObservations.openDialog()
    }
  }
}
</script>
